import { JobOfferingNotificationTranslation } from 'locales/de/pages/Messaging/jobOfferingNotifications';

const en: JobOfferingNotificationTranslation = {
  jobOfferingActive: 'The job offer is visible to students.',
  jobOfferingExpired: 'The job offer has expired.',
  jobOfferingEdited: 'The job offer has been edited.'
};

export default en;
